import React from 'react';
import { motion } from 'framer-motion';
export function DiagnosisSection() {
  const problems = [{
    number: '01',
    title: 'El lead de Zillow ya habló con tu competencia.',
    desc: 'Cuando compras un lead de portal, ese mismo lead fue vendido a 3 o 5 agentes más. El primero que llama gana. Y si no eres el primero en 2 minutos, ya perdiste la transacción.'
  }, {
    number: '02',
    title: 'No estás construyendo tu marca personal.',
    desc: 'En Real Estate, la gente no contrata a una agencia. Contrata a UNA persona. Si no tienes una marca personal de alta autoridad digital, eres intercambiable. Y lo intercambiable se elige por precio.'
  }, {
    number: '03',
    title: 'Tu base de datos de clientes pasados vale una fortuna que no estás cobrando.',
    desc: 'El 89% de los compradores dicen que usarían a su agente nuevamente. Pero solo el 12% lo hace. ¿Por qué? Porque el agente no tiene sistema de seguimiento.'
  }];
  return <section className="py-24 md:py-32 px-5 md:px-8 bg-carbon" data-id="element-103">
      <div className="max-w-4xl mx-auto" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 md:mb-24 border-l-4 border-gold pl-5 md:pl-6" data-id="element-105">
          <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight uppercase" data-id="element-106">
            El Diagnóstico
          </h2>
        </motion.div>

        <div className="space-y-12 md:space-y-16" data-id="element-107">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="flex flex-col md:flex-row gap-4 md:gap-10 border-b border-dark-100 pb-12 md:pb-16 last:border-0 last:pb-0" data-id="element-108">
              <div className="text-7xl md:text-8xl font-black text-gold/15 shrink-0 leading-none" data-id="element-109">
                {problem.number}
              </div>
              <div className="pt-2 md:pt-4" data-id="element-110">
                <h3 className="text-xl md:text-3xl font-bold text-white mb-4 leading-snug" data-id="element-111">
                  {problem.title}
                </h3>
                <p className="text-gray-400 text-base md:text-lg leading-relaxed" data-id="element-112">
                  {problem.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}